async function DesignSave (designid, designfolderid, notes, modifiedbyid, deleted, completedate) {

    if (
        designfolderid.length > 0 &&
        modifiedbyid.length > 0 &&
        deleted.length
    ) {

            let response;

            response = await fetch ("https://api.cssi.co/query", {
                method: "POST",
                body: JSON.stringify({
                    "sp": "67", 
                    "parameters": {
                        "@DesignId": designid,
                        "@DesignFolderId": designfolderid,
                        "@Notes": notes,
                        "@ModifiedById": modifiedbyid,
                        "@Deleted": deleted,
                        "@CompleteDate": completedate
                    },
                    "servername": "Compass-Svr3\\EXACTSQLEXPRESS", 
                    "databasename": "WebApps", 
                    "continuingfunction": null,
                    "noresults": false, 
                    "args": null
                })
            })
            .then(response => {
                return response.json();
            })
            .then((data) => {
                if (JSON.parse(data.payload).error.length > 0) {            
                    throw Error(JSON.parse(data.payload).error);
                }
                else {
                    response = JSON.parse(data.payload).data; 
                }
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);        
            })

            return response;

    }
}
 
export default DesignSave;